import { createIconComponent } from '../../factory/create-icon-component';
export const UKIcon = createIconComponent(
  'UKIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10027_30851)">
      <g filter="url(#filter0_dd_10027_30851)">
        <g clipPath="url(#clip1_10027_30851)">
          <rect x="1" y="5" width="22" height="15" rx="2" fill="#1A47B8" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.34035 5H1V7.5L20.6469 20L23 20V17.5L3.34035 5Z"
            fill="white"
          />
          <path
            d="M1.78058 5L23 18.5354V20L22.2377 20L1 6.45056V5H1.78058Z"
            fill="#F93939"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.9048 5H23V7.5C23 7.5 9.39122 15.8281 3.09524 20H1V17.5L20.9048 5Z"
            fill="white"
          />
          <path
            d="M23 5H22.2895L1 18.5471V20H1.78058L23 6.46151V5Z"
            fill="#F93939"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.00075 5H15.0176V9.62682H23V15.3701H15.0176V20H9.00075V15.3701H1V9.62682H9.00075V5Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2632 5H13.7368V10.7692H23V14.2308H13.7368V20H10.2632V14.2308H1V10.7692H10.2632V5Z"
            fill="#F93939"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_10027_30851"
        x="-0.959161"
        y="4.34695"
        width="25.9183"
        height="18.9183"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.30611" />
        <feGaussianBlur stdDeviation="0.97958" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.278431 0 0 0 0 0.298039 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10027_30851"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.0816317" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.278431 0 0 0 0 0.298039 0 0 0 0.32 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_10027_30851"
          result="effect2_dropShadow_10027_30851"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_10027_30851"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_10027_30851">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_10027_30851">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
